import { FC } from 'react'
import { IconTooltipWarning } from 'shared/components/IconTooltip'
import { getFormattedPriceWithRouble } from 'src/helpers/string'
import { PlaceholderCell } from 'src/tailwind-components/extends/PlaceholderCell'

import { OrderOperationItemSummary } from './types'

type OperationGroupProps = {
  operations: OrderOperationItemSummary[]
  hasTooltip?: boolean
  isLoading?: boolean
  terminalName?: string
}

export const OperationGroup: FC<OperationGroupProps> = ({
  isLoading,
  terminalName,
  operations,
  hasTooltip = false
}) => (
  <div className="flex w-full flex-col gap-1">
    {terminalName && <span className="text-label-lg">{terminalName}</span>}
    <div className="flex flex-col gap-1">
      {operations
        .sort((a, b) => a.operation.name.localeCompare(b.operation.name, 'ru'))
        .map((operation, index) => {
          const name =
            operation.source === 'order' || hasTooltip ? (
              <>
                <div>
                  {operation.operation.name}
                  {operation.amount > 1 && <>, {operation.amount} шт</>}
                </div>
                {operation.total ? (
                  <div className="whitespace-nowrap text-right">
                    {getFormattedPriceWithRouble(operation.total / 100)}
                  </div>
                ) : (
                  <div className="flex items-center gap-2 whitespace-nowrap">
                    —
                    <IconTooltipWarning className="text-on-surface-variant" size="xs">
                      Стоимость выбранных вами дополнительных услуг будет определена после приёма груза
                    </IconTooltipWarning>
                  </div>
                )}
              </>
            ) : (
              <>
                <div>
                  {operation.operation.name}
                  {operation.amount > 1 && <>, {operation.amount} шт</>}
                </div>
                <div className="whitespace-nowrap text-right">{getFormattedPriceWithRouble(operation.total / 100)}</div>
              </>
            )

          return (
            <div
              key={operation.operation.id + index}
              className="flex items-start justify-between gap-2 self-stretch text-body-md text-on-surface"
            >
              {isLoading ? <PlaceholderCell height={21} /> : name}
            </div>
          )
        })}
    </div>
  </div>
)
